<template>
  <li class="nav-item active">
    <router-link
      :class="pageClass + ' link nav-link d-none d-lg-block'"
      :to="'/' + title.toLowerCase()"
    >{{ title }}</router-link>
    <router-link
      :class="pageClass + ' link nav-link d-sm-block d-md-block d-lg-none'"
      :to="'/' + title.toLowerCase()"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
    >{{ title }}</router-link>
  </li>
</template>

<script>
export default {
  name: "NavbarMenuItem",
  props: {
    title: {
      type: String,
      default: ""
    },
    pageClass: {
      type: String,
      default: "black-navbar"
    }
  }
};
</script>

<style scoped>
.black-navbar {
  color: white;
}

.white-navbar {
  background: transparent;
  color: black;
}

@media (min-width: 992px) {
  .link {
    margin-right: 0.5rem;
  }
}

@media (min-width: 1200px) {
  .link {
    margin-right: 2rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fixed/navbar/navbar-menu-item.vue